import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children, requireAdmin = false, requirePanel = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Carregando…
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  const isAdmin = user.role === "admin";
  const canAccessPanel = Boolean(user.can_access_panel || isAdmin);

  if (requireAdmin && !isAdmin) {
    return <Navigate to={canAccessPanel ? "/painel" : "/admin/login"} replace />;
  }

  if (requirePanel && !canAccessPanel) {
    return <Navigate to={isAdmin ? "/admin" : "/admin/login"} replace />;
  }

  return children;
};

export default ProtectedRoute;
